var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _CompanyModel_company_id, _CompanyModel_name, _CompanyModel_legal_name, _CompanyModel_industry, _CompanyModel_company_size, _CompanyModel_founded_year, _CompanyModel_street_name, _CompanyModel_house_number, _CompanyModel_house_number_addition, _CompanyModel_zipcode, _CompanyModel_city, _CompanyModel_state_province, _CompanyModel_country, _CompanyModel_phone_number, _CompanyModel_whatsapp_number, _CompanyModel_email_address, _CompanyModel_website_url, _CompanyModel_vat_number, _CompanyModel_tax_id, _CompanyModel_iban, _CompanyModel_subscription_plan_cat, _CompanyModel_subscription_status_cat, _CompanyModel_max_users, _CompanyModel_max_assets, _CompanyModel_max_work_orders_per_month, _CompanyModel_billing_email, _CompanyModel_billing_cycle, _CompanyModel_timezone, _CompanyModel_currency, _CompanyModel_language, _CompanyModel_date_format, _CompanyModel_work_hours_start, _CompanyModel_work_hours_end, _CompanyModel_default_priority, _CompanyModel_auto_assign_enabled, _CompanyModel_notification_settings, _CompanyModel_status_cat, _CompanyModel_created_at, _CompanyModel_updated_at, _CompanyModel_trial_end_date;
import { isNotEmptyString, isValidEmail } from './utils/validationUtilities.js';
export var CompanyStatusCat;
(function (CompanyStatusCat) {
    CompanyStatusCat[CompanyStatusCat["TRIAL"] = 1] = "TRIAL";
    CompanyStatusCat[CompanyStatusCat["ACTIVE"] = 2] = "ACTIVE";
    CompanyStatusCat[CompanyStatusCat["INACTIVE"] = 3] = "INACTIVE";
})(CompanyStatusCat || (CompanyStatusCat = {}));
export var SubscriptionPlanCat;
(function (SubscriptionPlanCat) {
    SubscriptionPlanCat[SubscriptionPlanCat["STARTER"] = 1] = "STARTER";
    SubscriptionPlanCat[SubscriptionPlanCat["PROFESSIONAL"] = 2] = "PROFESSIONAL";
    SubscriptionPlanCat[SubscriptionPlanCat["ENTERPRISE"] = 3] = "ENTERPRISE";
})(SubscriptionPlanCat || (SubscriptionPlanCat = {}));
export var SubscriptionStatusCat;
(function (SubscriptionStatusCat) {
    SubscriptionStatusCat[SubscriptionStatusCat["TRIAL"] = 1] = "TRIAL";
    SubscriptionStatusCat[SubscriptionStatusCat["ACTIVE"] = 2] = "ACTIVE";
    SubscriptionStatusCat[SubscriptionStatusCat["EXPIRED"] = 3] = "EXPIRED";
    SubscriptionStatusCat[SubscriptionStatusCat["CANCELLED"] = 4] = "CANCELLED";
    SubscriptionStatusCat[SubscriptionStatusCat["SUSPENDED"] = 5] = "SUSPENDED";
})(SubscriptionStatusCat || (SubscriptionStatusCat = {}));
// Status text mappings
export const COMPANY_STATUS_TEXT = {
    [CompanyStatusCat.TRIAL]: 'Trial',
    [CompanyStatusCat.ACTIVE]: 'Active',
    [CompanyStatusCat.INACTIVE]: 'Inactive'
};
export const SUBSCRIPTION_PLAN_TEXT = {
    [SubscriptionPlanCat.STARTER]: 'Starter',
    [SubscriptionPlanCat.PROFESSIONAL]: 'Professional',
    [SubscriptionPlanCat.ENTERPRISE]: 'Enterprise'
};
export const SUBSCRIPTION_STATUS_TEXT = {
    [SubscriptionStatusCat.TRIAL]: 'Trial',
    [SubscriptionStatusCat.ACTIVE]: 'Active',
    [SubscriptionStatusCat.EXPIRED]: 'Expired',
    [SubscriptionStatusCat.CANCELLED]: 'Cancelled',
    [SubscriptionStatusCat.SUSPENDED]: 'Suspended'
};
export class CompanyModel {
    constructor(data = {}) {
        _CompanyModel_company_id.set(this, void 0);
        _CompanyModel_name.set(this, void 0);
        _CompanyModel_legal_name.set(this, void 0);
        _CompanyModel_industry.set(this, void 0);
        _CompanyModel_company_size.set(this, void 0);
        _CompanyModel_founded_year.set(this, void 0);
        _CompanyModel_street_name.set(this, void 0);
        _CompanyModel_house_number.set(this, void 0);
        _CompanyModel_house_number_addition.set(this, void 0);
        _CompanyModel_zipcode.set(this, void 0);
        _CompanyModel_city.set(this, void 0);
        _CompanyModel_state_province.set(this, void 0);
        _CompanyModel_country.set(this, void 0);
        _CompanyModel_phone_number.set(this, void 0);
        _CompanyModel_whatsapp_number.set(this, void 0);
        _CompanyModel_email_address.set(this, void 0);
        _CompanyModel_website_url.set(this, void 0);
        _CompanyModel_vat_number.set(this, void 0);
        _CompanyModel_tax_id.set(this, void 0);
        _CompanyModel_iban.set(this, void 0);
        _CompanyModel_subscription_plan_cat.set(this, void 0);
        _CompanyModel_subscription_status_cat.set(this, void 0);
        _CompanyModel_max_users.set(this, void 0);
        _CompanyModel_max_assets.set(this, void 0);
        _CompanyModel_max_work_orders_per_month.set(this, void 0);
        _CompanyModel_billing_email.set(this, void 0);
        _CompanyModel_billing_cycle.set(this, void 0);
        _CompanyModel_timezone.set(this, void 0);
        _CompanyModel_currency.set(this, void 0);
        _CompanyModel_language.set(this, void 0);
        _CompanyModel_date_format.set(this, void 0);
        _CompanyModel_work_hours_start.set(this, void 0);
        _CompanyModel_work_hours_end.set(this, void 0);
        _CompanyModel_default_priority.set(this, void 0);
        _CompanyModel_auto_assign_enabled.set(this, void 0);
        _CompanyModel_notification_settings.set(this, void 0);
        _CompanyModel_status_cat.set(this, void 0);
        _CompanyModel_created_at.set(this, void 0);
        _CompanyModel_updated_at.set(this, void 0);
        _CompanyModel_trial_end_date.set(this, void 0);
        this.company_id = data.company_id || this.generateId();
        this.name = data.name || '';
        this.legal_name = data.legal_name || '';
        this.industry = data.industry || '';
        this.company_size = data.company_size || 0;
        this.founded_year = data.founded_year || null;
        this.street_name = data.street_name || '';
        this.house_number = data.house_number || '';
        this.house_number_addition = data.house_number_addition || null;
        this.zipcode = data.zipcode || '';
        this.city = data.city || '';
        this.state_province = data.state_province || '';
        this.country = data.country || '';
        this.phone_number = data.phone_number || '';
        this.whatsapp_number = data.whatsapp_number || null;
        this.email_address = data.email_address || '';
        this.website_url = data.website_url || null;
        this.vat_number = data.vat_number || null;
        this.tax_id = data.tax_id || null;
        this.iban = data.iban || null;
        this.subscription_plan_cat = data.subscription_plan_cat || SubscriptionPlanCat.STARTER;
        this.subscription_status_cat = data.subscription_status_cat || SubscriptionStatusCat.TRIAL;
        this.max_users = data.max_users || 5;
        this.max_assets = data.max_assets || 50;
        this.max_work_orders_per_month = data.max_work_orders_per_month || 100;
        this.billing_email = data.billing_email || '';
        this.billing_cycle = data.billing_cycle || 'Monthly';
        this.timezone = data.timezone || 'Europe/Amsterdam';
        this.currency = data.currency || 'EUR';
        this.language = data.language || 'nl';
        this.date_format = data.date_format || 'DD/MM/YYYY';
        this.work_hours_start = data.work_hours_start || '08:00';
        this.work_hours_end = data.work_hours_end || '17:00';
        this.default_priority = data.default_priority || 'Medium';
        this.auto_assign_enabled = data.auto_assign_enabled || false;
        this.notification_settings = data.notification_settings || {};
        this.status_cat = data.status_cat || CompanyStatusCat.TRIAL;
        this.created_at = data.created_at || Date.now();
        this.updated_at = data.updated_at || Date.now();
        this.trial_end_date = data.trial_end_date || null;
    }
    // Getters and Setters
    get company_id() {
        return __classPrivateFieldGet(this, _CompanyModel_company_id, "f");
    }
    set company_id(company_id) {
        if (!isNotEmptyString(company_id)) {
            throw new Error('Company ID is required and must be a non-empty string');
        }
        __classPrivateFieldSet(this, _CompanyModel_company_id, company_id, "f");
    }
    get name() {
        return __classPrivateFieldGet(this, _CompanyModel_name, "f");
    }
    set name(name) {
        if (!isNotEmptyString(name)) {
            throw new Error('Name is required and must be a non-empty string');
        }
        if (name.length > 100) {
            throw new Error('Name must be 100 characters or less');
        }
        __classPrivateFieldSet(this, _CompanyModel_name, name, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get legal_name() {
        return __classPrivateFieldGet(this, _CompanyModel_legal_name, "f");
    }
    set legal_name(legal_name) {
        if (legal_name && legal_name.length > 100) {
            throw new Error('Legal name must be 100 characters or less');
        }
        __classPrivateFieldSet(this, _CompanyModel_legal_name, legal_name, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get industry() {
        return __classPrivateFieldGet(this, _CompanyModel_industry, "f");
    }
    set industry(industry) {
        if (industry && industry.length > 50) {
            throw new Error('Industry must be 50 characters or less');
        }
        __classPrivateFieldSet(this, _CompanyModel_industry, industry, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get company_size() {
        return __classPrivateFieldGet(this, _CompanyModel_company_size, "f");
    }
    set company_size(company_size) {
        if (company_size < 0) {
            throw new Error('Company size must be a positive number');
        }
        __classPrivateFieldSet(this, _CompanyModel_company_size, company_size, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get founded_year() {
        return __classPrivateFieldGet(this, _CompanyModel_founded_year, "f");
    }
    set founded_year(founded_year) {
        if (founded_year !== null) {
            const currentYear = new Date().getFullYear();
            if (founded_year < 1800 || founded_year > currentYear) {
                throw new Error(`Founded year must be between 1800 and ${currentYear}`);
            }
        }
        __classPrivateFieldSet(this, _CompanyModel_founded_year, founded_year, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get street_name() {
        return __classPrivateFieldGet(this, _CompanyModel_street_name, "f");
    }
    set street_name(street_name) {
        if (street_name && street_name.length > 100) {
            throw new Error('Street name must be 100 characters or less');
        }
        __classPrivateFieldSet(this, _CompanyModel_street_name, street_name, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get house_number() {
        return __classPrivateFieldGet(this, _CompanyModel_house_number, "f");
    }
    set house_number(house_number) {
        __classPrivateFieldSet(this, _CompanyModel_house_number, house_number, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get house_number_addition() {
        return __classPrivateFieldGet(this, _CompanyModel_house_number_addition, "f");
    }
    set house_number_addition(house_number_addition) {
        if (house_number_addition !== null && !isNotEmptyString(house_number_addition)) {
            throw new Error('House number addition must be a non-empty string if provided');
        }
        __classPrivateFieldSet(this, _CompanyModel_house_number_addition, house_number_addition, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get zipcode() {
        return __classPrivateFieldGet(this, _CompanyModel_zipcode, "f");
    }
    set zipcode(zipcode) {
        __classPrivateFieldSet(this, _CompanyModel_zipcode, zipcode, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get city() {
        return __classPrivateFieldGet(this, _CompanyModel_city, "f");
    }
    set city(city) {
        if (city && city.length > 50) {
            throw new Error('City must be 50 characters or less');
        }
        __classPrivateFieldSet(this, _CompanyModel_city, city, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get state_province() {
        return __classPrivateFieldGet(this, _CompanyModel_state_province, "f");
    }
    set state_province(state_province) {
        if (state_province && state_province.length > 50) {
            throw new Error('State/Province must be 50 characters or less');
        }
        __classPrivateFieldSet(this, _CompanyModel_state_province, state_province, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get country() {
        return __classPrivateFieldGet(this, _CompanyModel_country, "f");
    }
    set country(country) {
        if (country && country.length > 50) {
            throw new Error('Country must be 50 characters or less');
        }
        __classPrivateFieldSet(this, _CompanyModel_country, country, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get phone_number() {
        return __classPrivateFieldGet(this, _CompanyModel_phone_number, "f");
    }
    set phone_number(phone_number) {
        if (!isNotEmptyString(phone_number)) {
            throw new Error('Phone number is required and must be a non-empty string');
        }
        __classPrivateFieldSet(this, _CompanyModel_phone_number, phone_number, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get whatsapp_number() {
        return __classPrivateFieldGet(this, _CompanyModel_whatsapp_number, "f");
    }
    set whatsapp_number(whatsapp_number) {
        if (whatsapp_number !== null && !isNotEmptyString(whatsapp_number)) {
            throw new Error('WhatsApp number must be a non-empty string if provided');
        }
        __classPrivateFieldSet(this, _CompanyModel_whatsapp_number, whatsapp_number, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get email_address() {
        return __classPrivateFieldGet(this, _CompanyModel_email_address, "f");
    }
    set email_address(email_address) {
        if (!isNotEmptyString(email_address)) {
            throw new Error('Email address is required and must be a non-empty string');
        }
        if (!isValidEmail(email_address)) {
            throw new Error('Email address must be a valid email format');
        }
        __classPrivateFieldSet(this, _CompanyModel_email_address, email_address, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get website_url() {
        let url = __classPrivateFieldGet(this, _CompanyModel_website_url, "f") || '';
        if (url && !/^https?:\/\//i.test(url)) {
            url = 'https://' + url;
        }
        return url || null;
    }
    set website_url(website_url) {
        if (website_url !== null && !isNotEmptyString(website_url)) {
            throw new Error('Website URL must be a non-empty string if provided');
        }
        __classPrivateFieldSet(this, _CompanyModel_website_url, website_url, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get vat_number() {
        return __classPrivateFieldGet(this, _CompanyModel_vat_number, "f");
    }
    set vat_number(vat_number) {
        if (vat_number !== null && !isNotEmptyString(vat_number)) {
            throw new Error('VAT number must be a non-empty string if provided');
        }
        __classPrivateFieldSet(this, _CompanyModel_vat_number, vat_number, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get tax_id() {
        return __classPrivateFieldGet(this, _CompanyModel_tax_id, "f");
    }
    set tax_id(tax_id) {
        if (tax_id !== null && !isNotEmptyString(tax_id)) {
            throw new Error('Tax ID must be a non-empty string if provided');
        }
        __classPrivateFieldSet(this, _CompanyModel_tax_id, tax_id, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get iban() {
        return __classPrivateFieldGet(this, _CompanyModel_iban, "f");
    }
    set iban(iban) {
        if (iban !== null && !isNotEmptyString(iban)) {
            throw new Error('IBAN must be a non-empty string if provided');
        }
        __classPrivateFieldSet(this, _CompanyModel_iban, iban, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get subscription_plan_cat() {
        return __classPrivateFieldGet(this, _CompanyModel_subscription_plan_cat, "f");
    }
    set subscription_plan_cat(subscription_plan_cat) {
        if (!Object.values(SubscriptionPlanCat).includes(subscription_plan_cat)) {
            throw new Error('Invalid subscription plan category');
        }
        __classPrivateFieldSet(this, _CompanyModel_subscription_plan_cat, subscription_plan_cat, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get subscription_status_cat() {
        return __classPrivateFieldGet(this, _CompanyModel_subscription_status_cat, "f");
    }
    set subscription_status_cat(subscription_status_cat) {
        if (!Object.values(SubscriptionStatusCat).includes(subscription_status_cat)) {
            throw new Error('Invalid subscription status category');
        }
        __classPrivateFieldSet(this, _CompanyModel_subscription_status_cat, subscription_status_cat, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get max_users() {
        return __classPrivateFieldGet(this, _CompanyModel_max_users, "f");
    }
    set max_users(max_users) {
        if (max_users < 1) {
            throw new Error('Max users must be at least 1');
        }
        __classPrivateFieldSet(this, _CompanyModel_max_users, max_users, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get max_assets() {
        return __classPrivateFieldGet(this, _CompanyModel_max_assets, "f");
    }
    set max_assets(max_assets) {
        if (max_assets < 0) {
            throw new Error('Max assets must be a positive number');
        }
        __classPrivateFieldSet(this, _CompanyModel_max_assets, max_assets, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get max_work_orders_per_month() {
        return __classPrivateFieldGet(this, _CompanyModel_max_work_orders_per_month, "f");
    }
    set max_work_orders_per_month(max_work_orders_per_month) {
        if (max_work_orders_per_month < 0) {
            throw new Error('Max work orders per month must be a positive number');
        }
        __classPrivateFieldSet(this, _CompanyModel_max_work_orders_per_month, max_work_orders_per_month, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get billing_email() {
        return __classPrivateFieldGet(this, _CompanyModel_billing_email, "f");
    }
    set billing_email(billing_email) {
        if (billing_email && !isValidEmail(billing_email)) {
            throw new Error('Billing email must be a valid email format');
        }
        __classPrivateFieldSet(this, _CompanyModel_billing_email, billing_email, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get billing_cycle() {
        return __classPrivateFieldGet(this, _CompanyModel_billing_cycle, "f");
    }
    set billing_cycle(billing_cycle) {
        if (billing_cycle !== 'Monthly' && billing_cycle !== 'Yearly') {
            throw new Error('Billing cycle must be either Monthly or Yearly');
        }
        __classPrivateFieldSet(this, _CompanyModel_billing_cycle, billing_cycle, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get timezone() {
        return __classPrivateFieldGet(this, _CompanyModel_timezone, "f");
    }
    set timezone(timezone) {
        __classPrivateFieldSet(this, _CompanyModel_timezone, timezone, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get currency() {
        return __classPrivateFieldGet(this, _CompanyModel_currency, "f");
    }
    set currency(currency) {
        __classPrivateFieldSet(this, _CompanyModel_currency, currency, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get language() {
        return __classPrivateFieldGet(this, _CompanyModel_language, "f");
    }
    set language(language) {
        __classPrivateFieldSet(this, _CompanyModel_language, language, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get date_format() {
        return __classPrivateFieldGet(this, _CompanyModel_date_format, "f");
    }
    set date_format(date_format) {
        __classPrivateFieldSet(this, _CompanyModel_date_format, date_format, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get work_hours_start() {
        return __classPrivateFieldGet(this, _CompanyModel_work_hours_start, "f");
    }
    set work_hours_start(work_hours_start) {
        // Validate time format HH:MM if provided
        if (work_hours_start && !/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(work_hours_start)) {
            throw new Error('Work hours start must be in HH:MM format');
        }
        __classPrivateFieldSet(this, _CompanyModel_work_hours_start, work_hours_start, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get work_hours_end() {
        return __classPrivateFieldGet(this, _CompanyModel_work_hours_end, "f");
    }
    set work_hours_end(work_hours_end) {
        // Validate time format HH:MM if provided
        if (work_hours_end && !/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(work_hours_end)) {
            throw new Error('Work hours end must be in HH:MM format');
        }
        __classPrivateFieldSet(this, _CompanyModel_work_hours_end, work_hours_end, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get default_priority() {
        return __classPrivateFieldGet(this, _CompanyModel_default_priority, "f");
    }
    set default_priority(default_priority) {
        const validPriorities = ['Low', 'Medium', 'High', 'Critical'];
        if (!validPriorities.includes(default_priority)) {
            throw new Error('Default priority must be Low, Medium, High, or Critical');
        }
        __classPrivateFieldSet(this, _CompanyModel_default_priority, default_priority, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get auto_assign_enabled() {
        return __classPrivateFieldGet(this, _CompanyModel_auto_assign_enabled, "f");
    }
    set auto_assign_enabled(auto_assign_enabled) {
        if (typeof auto_assign_enabled !== 'boolean') {
            throw new Error('Auto assign enabled must be a boolean');
        }
        __classPrivateFieldSet(this, _CompanyModel_auto_assign_enabled, auto_assign_enabled, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get notification_settings() {
        return __classPrivateFieldGet(this, _CompanyModel_notification_settings, "f");
    }
    set notification_settings(notification_settings) {
        if (typeof notification_settings !== 'object' || notification_settings === null) {
            throw new Error('Notification settings must be an object');
        }
        __classPrivateFieldSet(this, _CompanyModel_notification_settings, notification_settings, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get status_cat() {
        return __classPrivateFieldGet(this, _CompanyModel_status_cat, "f");
    }
    set status_cat(status_cat) {
        if (!Object.values(CompanyStatusCat).includes(status_cat)) {
            throw new Error('Invalid status category');
        }
        __classPrivateFieldSet(this, _CompanyModel_status_cat, status_cat, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    get created_at() {
        return __classPrivateFieldGet(this, _CompanyModel_created_at, "f");
    }
    set created_at(created_at) {
        __classPrivateFieldSet(this, _CompanyModel_created_at, created_at, "f");
    }
    get updated_at() {
        return __classPrivateFieldGet(this, _CompanyModel_updated_at, "f");
    }
    set updated_at(updated_at) {
        __classPrivateFieldSet(this, _CompanyModel_updated_at, updated_at, "f");
    }
    get trial_end_date() {
        return __classPrivateFieldGet(this, _CompanyModel_trial_end_date, "f");
    }
    set trial_end_date(trial_end_date) {
        __classPrivateFieldSet(this, _CompanyModel_trial_end_date, trial_end_date, "f");
        __classPrivateFieldSet(this, _CompanyModel_updated_at, Date.now(), "f");
    }
    // Helper methods
    static get statusCategories() {
        return Object.values(CompanyStatusCat).filter((value) => typeof value === 'number');
    }
    static get subscriptionPlanCategories() {
        return Object.values(SubscriptionPlanCat).filter((value) => typeof value === 'number');
    }
    static get subscriptionStatusCategories() {
        return Object.values(SubscriptionStatusCat).filter((value) => typeof value === 'number');
    }
    // Text helper methods
    getStatusText() {
        return COMPANY_STATUS_TEXT[this.status_cat];
    }
    getSubscriptionPlanText() {
        return SUBSCRIPTION_PLAN_TEXT[this.subscription_plan_cat];
    }
    getSubscriptionStatusText() {
        return SUBSCRIPTION_STATUS_TEXT[this.subscription_status_cat];
    }
    isActive() {
        return this.status_cat === CompanyStatusCat.ACTIVE;
    }
    isInactive() {
        return this.status_cat === CompanyStatusCat.INACTIVE;
    }
    isTrial() {
        return this.status_cat === CompanyStatusCat.TRIAL;
    }
    isTrialExpired() {
        if (!this.trial_end_date)
            return false;
        return Date.now() > this.trial_end_date;
    }
    getFullAddress() {
        const parts = [
            this.street_name,
            this.house_number,
            this.house_number_addition,
            this.zipcode,
            this.city,
            this.state_province,
            this.country
        ].filter(part => part && part.trim() !== '');
        return parts.join(', ');
    }
    toJSON() {
        return {
            company_id: this.company_id,
            name: this.name,
            legal_name: this.legal_name,
            industry: this.industry,
            company_size: this.company_size,
            founded_year: this.founded_year,
            street_name: this.street_name,
            house_number: this.house_number,
            house_number_addition: this.house_number_addition,
            zipcode: this.zipcode,
            city: this.city,
            state_province: this.state_province,
            country: this.country,
            phone_number: this.phone_number,
            whatsapp_number: this.whatsapp_number,
            email_address: this.email_address,
            website_url: this.website_url,
            vat_number: this.vat_number,
            tax_id: this.tax_id,
            iban: this.iban,
            subscription_plan_cat: this.subscription_plan_cat,
            subscription_plan_text: this.getSubscriptionPlanText(),
            subscription_status_cat: this.subscription_status_cat,
            subscription_status_text: this.getSubscriptionStatusText(),
            max_users: this.max_users,
            max_assets: this.max_assets,
            max_work_orders_per_month: this.max_work_orders_per_month,
            billing_email: this.billing_email,
            billing_cycle: this.billing_cycle,
            timezone: this.timezone,
            currency: this.currency,
            language: this.language,
            date_format: this.date_format,
            work_hours_start: this.work_hours_start,
            work_hours_end: this.work_hours_end,
            default_priority: this.default_priority,
            auto_assign_enabled: this.auto_assign_enabled,
            notification_settings: this.notification_settings,
            status_cat: this.status_cat,
            status_text: this.getStatusText(),
            created_at: this.created_at,
            updated_at: this.updated_at,
            trial_end_date: this.trial_end_date
        };
    }
    toFirestore() {
        return {
            company_id: this.company_id,
            name: this.name,
            legal_name: this.legal_name,
            industry: this.industry,
            company_size: this.company_size,
            founded_year: this.founded_year,
            street_name: this.street_name,
            house_number: this.house_number,
            house_number_addition: this.house_number_addition,
            zipcode: this.zipcode,
            city: this.city,
            state_province: this.state_province,
            country: this.country,
            phone_number: this.phone_number,
            whatsapp_number: this.whatsapp_number,
            email_address: this.email_address,
            website_url: this.website_url,
            vat_number: this.vat_number,
            tax_id: this.tax_id,
            iban: this.iban,
            subscription_plan_cat: this.subscription_plan_cat,
            subscription_plan_text: this.getSubscriptionPlanText(),
            subscription_status_cat: this.subscription_status_cat,
            subscription_status_text: this.getSubscriptionStatusText(),
            max_users: this.max_users,
            max_assets: this.max_assets,
            max_work_orders_per_month: this.max_work_orders_per_month,
            billing_email: this.billing_email,
            billing_cycle: this.billing_cycle,
            timezone: this.timezone,
            currency: this.currency,
            language: this.language,
            date_format: this.date_format,
            work_hours_start: this.work_hours_start,
            work_hours_end: this.work_hours_end,
            default_priority: this.default_priority,
            auto_assign_enabled: this.auto_assign_enabled,
            notification_settings: this.notification_settings,
            status_cat: this.status_cat,
            status_text: this.getStatusText(),
            created_at: this.created_at,
            updated_at: this.updated_at,
            trial_end_date: this.trial_end_date
        };
    }
    generateId() {
        return 'company_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    }
}
_CompanyModel_company_id = new WeakMap(), _CompanyModel_name = new WeakMap(), _CompanyModel_legal_name = new WeakMap(), _CompanyModel_industry = new WeakMap(), _CompanyModel_company_size = new WeakMap(), _CompanyModel_founded_year = new WeakMap(), _CompanyModel_street_name = new WeakMap(), _CompanyModel_house_number = new WeakMap(), _CompanyModel_house_number_addition = new WeakMap(), _CompanyModel_zipcode = new WeakMap(), _CompanyModel_city = new WeakMap(), _CompanyModel_state_province = new WeakMap(), _CompanyModel_country = new WeakMap(), _CompanyModel_phone_number = new WeakMap(), _CompanyModel_whatsapp_number = new WeakMap(), _CompanyModel_email_address = new WeakMap(), _CompanyModel_website_url = new WeakMap(), _CompanyModel_vat_number = new WeakMap(), _CompanyModel_tax_id = new WeakMap(), _CompanyModel_iban = new WeakMap(), _CompanyModel_subscription_plan_cat = new WeakMap(), _CompanyModel_subscription_status_cat = new WeakMap(), _CompanyModel_max_users = new WeakMap(), _CompanyModel_max_assets = new WeakMap(), _CompanyModel_max_work_orders_per_month = new WeakMap(), _CompanyModel_billing_email = new WeakMap(), _CompanyModel_billing_cycle = new WeakMap(), _CompanyModel_timezone = new WeakMap(), _CompanyModel_currency = new WeakMap(), _CompanyModel_language = new WeakMap(), _CompanyModel_date_format = new WeakMap(), _CompanyModel_work_hours_start = new WeakMap(), _CompanyModel_work_hours_end = new WeakMap(), _CompanyModel_default_priority = new WeakMap(), _CompanyModel_auto_assign_enabled = new WeakMap(), _CompanyModel_notification_settings = new WeakMap(), _CompanyModel_status_cat = new WeakMap(), _CompanyModel_created_at = new WeakMap(), _CompanyModel_updated_at = new WeakMap(), _CompanyModel_trial_end_date = new WeakMap();
//# sourceMappingURL=CompanyModel.js.map